import cl from "classnames";
import { useTranslation } from "react-i18next";

import cls from "./Sidebar.module.css";

import { CreateOrCopyCampaign } from "@/features/campaign/createOrCopy/ui/CreateOrCopyCampaign";
import { TUTORIAL_ANCHORS, tutorialAnchor } from "@/features/tutorial";
import PlusCircleIcon from "@/shared/assets/icons/plusCircleIcon.svg";

export const CreateCampaignButton = ({ open }: { open: boolean }) => {
    const { t } = useTranslation();

    return (
        <div
            className={cls["create-campaign-wrapper"]}
            {...tutorialAnchor(TUTORIAL_ANCHORS.CREATE_CAMPAIGN)}
        >
            <CreateOrCopyCampaign
                dropdownWidth="100%"
                position={open ? "rightBottom" : "leftBottom"}
                triggerClassName={cl(cls["create-campaign"], { [cls.close]: !open })}
                qaButton="sidebar-create-menu-button"
            >
                <PlusCircleIcon className={cls.icon} />
                {open && <span className={cls["button-text"]}>{t("sidebar.create-campaign")}</span>}
            </CreateOrCopyCampaign>
        </div>
    );
};
